import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  primaryAction,
  secondaryAction,
  className = '',
}) => {
  return (
    <Card
      className={`bg-white border border-[var(--ns-border)] rounded-2xl shadow-[var(--ns-shadow-soft)] ${className}`}
    >
      <CardContent className="flex flex-col items-center text-center py-10 sm:py-14 px-6">
        {Icon && (
          <div className="h-14 w-14 rounded-2xl bg-[var(--ns-amber-100)] border border-[var(--ns-gold)]/40 flex items-center justify-center mb-5">
            <Icon className="h-7 w-7 text-[var(--ns-gold-700)]" />
          </div>
        )}
        {title && (
          <h3 className="font-display uppercase tracking-wide text-2xl sm:text-3xl text-[var(--ns-text)] mb-2">
            {title}
          </h3>
        )}
        {description && (
          <p className="text-sm sm:text-base text-[var(--ns-text-muted)] max-w-md leading-relaxed">
            {description}
          </p>
        )}
        {(primaryAction || secondaryAction) && (
          <div className="flex flex-col sm:flex-row gap-3 mt-7 w-full sm:w-auto">
            {primaryAction && (
              <Button
                asChild
                className="h-11 px-5 rounded-xl bg-gradient-to-r from-[var(--ns-gold)] to-[var(--ns-gold-600)] text-[#1c1612] font-semibold hover:from-[var(--ns-gold-600)] hover:to-[var(--ns-gold-700)] hover:text-white hover:shadow-[var(--ns-glow-gold)] shadow-[var(--ns-shadow-soft)] border-0 transition-all duration-200"
                data-testid={primaryAction.testId}
              >
                <Link to={primaryAction.to}>{primaryAction.label}</Link>
              </Button>
            )}
            {secondaryAction && (
              <Button
                asChild
                variant="outline"
                className="h-11 px-5 rounded-xl bg-white border-[var(--ns-border-strong)] text-[var(--ns-text)] hover:bg-[var(--ns-amber-50)] hover:border-[var(--ns-gold)]"
                data-testid={secondaryAction.testId}
              >
                <Link to={secondaryAction.to}>{secondaryAction.label}</Link>
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
